import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';

import GreenArrowIcon from 'public/icons/left-arrow-green.svg';
import RedArrowIcon from 'public/icons/left-arrow-red.svg';

const PercentageDifference = ({ defaultBudget, profileBudget, marginTop }) => {
  const defaultIsHigher = defaultBudget > profileBudget;
  const percentage = Math.abs((((profileBudget - defaultBudget) / defaultBudget) * 100).toFixed(2));

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const getColor = () => {
    if (defaultIsHigher) return '#57c88c';
    return '#ff4b4b';
  };

  const getMargin = () => {
    if (!marginTop) return '0 0 0 5px';
    return isDesktop ? '0 0 0 2px' : '5px 0 0 0';
  };

  const getIcon = () => {
    if (defaultIsHigher)
      return (
        <div style={{ transform: 'rotate(270deg)' }}>
          <GreenArrowIcon width={8} height={8} />
        </div>
      );

    return (
      <div style={{ transform: 'rotate(90deg)' }}>
        <RedArrowIcon width={8} height={8} />
      </div>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        color: getColor(),
        margin: getMargin(),

        fontSize: 12,
      }}
    >
      <div style={{ margin: '0px 2px' }}>{getIcon()}</div>
      <strong>{percentage}%</strong>
    </div>
  );
};

export default PercentageDifference;
